<template>
  <div class="cb-error-modal" @keydown="setFocus">
    <img v-if="icon" class="cb-error-modal__icon" v-bind="icon"/>
    <h1 v-if="title" class="cb-heading-3" id="dialog-title">
      {{ title }}
    </h1>
    <p class="cb-body-1 cb-error-modal__body">{{ errorModal.body }}</p>
    <button
      @click="handleTryAgain"
      class="cb-button cb-button--blue"
      ref="tryAgain"
      data-tab-order="first"
    >
      {{ errorModal.tryAgainDestination === '' ? 'Close' : 'Try Again' }}
    </button>
    <button
      @click="handleTroubleshoot"
      class="cb-button cb-button--outline-blue"
      v-if="errorModal.showTroubleshoot"
    >
      Troubleshoot
    </button>
    <!-- <button
      @click="handleLiveChatClick"
      :disabled="isLiveChatOpen || isLiveChatExpanded"
      class="cb-button cb-button--outline cb-button--live-chat"
      v-if="validLiveChatHours && errorModal.showLiveChat"
    >
      Live Chat
      <span class="cb-button--live-chat__icon"></span>
    </button> -->
    <div class="cb-error-modal__divider"></div>
    <cb-assistance :tabOrder="'last'"></cb-assistance>
  </div>
</template>

<script>
/* global gtag */
import { mapActions, mapMutations, mapState } from 'vuex';
// import isLivechatActive from '../../utility/livechat';
import Assistance from '../shared/Assistance.vue';
import focusTrapping from '../../mixins/focusTrapping';

const ERROR_CODE = {
  LOCKED: 1001,
  UNAUTHORIZED: 401,
  UNDEFINED: undefined,
};

export default {
  // data() {
  //   return {
  //     validLiveChatHours: false,
  //   };
  // },
  computed: {
    ...mapState({
      // isLiveChatOpen: (state) => state.isLiveChatOpen,
      // isLiveChatExpanded: (state) => state.isLiveChatExpanded,
      errorModal: (state) => state.errorModal,
    }),
    icon() {
      if (this.errorModal.errorCode === ERROR_CODE.LOCKED) {
        return {
          alt: 'warning icon',
          class: 'round-icon',
          // eslint-disable-next-line global-require
          src: require('../../assets/icons/exclamation-point.svg'),
        };
      }
      if (this.errorModal.errorCode === ERROR_CODE.UNDEFINED) return null;
      return {
        alt: 'try again icon',
        // eslint-disable-next-line global-require
        src: require('../../assets/icons/refresh-icon.svg'),
      };
    },
    title() {
      if (this.errorModal.errorCode === ERROR_CODE.LOCKED) {
        return 'Account Locked';
      }
      if (this.errorModal.errorCode === ERROR_CODE.UNDEFINED) return null;
      return 'Oops, that didn\'t go as expected';
    },
  },
  // beforeMount() {
  //   this.validLiveChatHours = isLivechatActive();
  // },
  mounted() {
    this.$refs.tryAgain.focus();
    document.title = "Cellbridge - Oops, that didn't go as expected";
  },
  methods: {
    handleTryAgain() {
      if (this.errorModal.tryAgainDestination === '') {
        this.closeModal();
      } else {
        this.updateManualTestStep('1');
        this.$router.push(this.errorModal.tryAgainDestination);
      }
      gtag('event', 'retryClick', {
        event_label: 'retry',
        event_category: 'deviceError',
        value: 1,
      });
    },
    handleTroubleshoot() {
      this.closeModal();
      this.$router.push('troubleshoot');
      gtag('event', 'troubleshootClick', {
        event_label: 'troubleshoot',
        event_category: 'deviceError',
        value: 1,
      });
    },
    // handleLiveChatClick() {
    //   this.toggleLiveChat();
    //   gtag('event', 'liveChatClick', {
    //     event_label: 'live chat',
    //     event_category: 'deviceError',
    //     value: 1,
    //   });
    // },
    ...mapActions(['closeModal']),
    ...mapMutations(['updateManualTestStep']),
  },
  mixins: [focusTrapping],
  components: {
    cbAssistance: Assistance,
  },
};
</script>

<style lang="scss" scoped>

.cb-error-modal {
  --icon-size: 56px;
  display: flex;
  flex-direction: column;
  width: 88vw;
  max-width: 430px;
  box-sizing: border-box;
  padding: 40px 20px 16px;

  &__icon {
    height: var(--icon-size);
    margin: 20px 0 16px;
    &.round-icon{
      background-color: #008cfd;
      border-radius: 100px;
      box-sizing: border-box;
      margin: 20px auto 16px auto;
      padding: 16px;
      width: var(--icon-size);
    }
  }

  .cb-heading-3 {
    text-align: center;
    margin-bottom: 16px;
  }

  &__body {
    text-align: center;
    margin-bottom: 28px;
  }

  .cb-button {
    margin-bottom: 16px;
  }

  &__divider {
    display: block;
    height: 1px;
    background-color: $light-blue-grey;
    margin: 12px 0 16px;
  }

  @include desktop {
    padding: 60px 40px 28px;

    &__icon {
      --icon-size: 75px;
      margin: 20px 0 28px;
      &.round-icon{
        margin: 20px auto 16px auto;
        padding: 20px;
      }
    }

    .cb-heading-3 {
      font-size: 36px;
      line-height: 50px;
      margin-bottom: 12px;
    }

    .cb-button {
      margin-bottom: 20px;
    }

    &__divider {
      margin: 0 0 28px;
    }
  }
}
</style>
